import { API_HOST } from 'src/shared/constants';

interface ClientIdResponse {
  client_id: string;
}

const API_URL = `${API_HOST}/api/v1`;

export async function getClientId(token: string): Promise<ClientIdResponse> {
  const res = await fetch(`${API_URL}/ws/client`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  return await res.json();
}
